import { SPECIALITY_ICON_NAME_PATTERN } from '@dermloop/static-values';
import {
  IsInt,
  IsNotEmpty,
  IsOptional,
  IsString,
  Matches,
  Min,
  ValidateIf,
} from 'class-validator';
import { BaseCreateDto, BaseUpdateDto } from './base.dto';
import { NamedEntityDto } from './clinical-details';

export class SpecialityDto extends NamedEntityDto {
  /**
   * Font Awesome kit icon name without the `fa-` prefix, e.g.
   * `speciality-oral-medicine`. Undefined until artwork is uploaded to the kit.
   */
  @IsOptional()
  @IsString()
  @Matches(SPECIALITY_ICON_NAME_PATTERN)
  icon?: string;

  /** Display position, ascending; ties break on name. */
  @IsOptional()
  @IsInt()
  ordering?: number;
}

export class CreateSpecialityDto
  extends BaseCreateDto
  implements Partial<SpecialityDto>
{
  @IsNotEmpty()
  @IsString()
  name: string;

  @IsOptional()
  @IsString()
  name_da?: string;

  @IsOptional()
  @IsString()
  name_de?: string;

  @IsOptional()
  @IsString()
  @Matches(SPECIALITY_ICON_NAME_PATTERN)
  icon?: string;

  @IsInt()
  @Min(0)
  ordering: number;
}

export class UpdateSpecialityDto extends BaseUpdateDto {
  @ValidateIf((_, value) => value !== undefined)
  @IsNotEmpty()
  @IsString()
  name?: string;

  @IsOptional()
  @IsString()
  name_da?: string | null;

  @IsOptional()
  @IsString()
  name_de?: string | null;

  /** Null clears it; clients fall back to a generic icon. */
  @IsOptional()
  @IsString()
  @Matches(SPECIALITY_ICON_NAME_PATTERN)
  icon?: string | null;
}
